export const formatDynamicValue = discountValue => {
  if (!discountValue) {
    return discountValue;
  }
  return discountValue.split(/\n/).map((dynamic, index) => index > 0 ? dynamic.charAt(0).toLowerCase() + dynamic.slice(1) : dynamic).join(' ');
};
//# sourceMappingURL=formatDynamicValue.js.map